
import Event = createjs.Event;

export class Poker2DialogEvent extends Event {
    public static SELECT_NAME: string = "selectName";
    public static CHANGE_LAYOUTSTATE: string = "changelayoutstate";
    public static MOUSE_ON_DIALOG: string = "mouseondialog";
    public static CHANGE_WORLD: string = "changeworld";
    public static MENUE_SELECTION: string = "menueselection";
    public static ON_SWITCH_SCREEN: string = "onswtichscreen";
    public static ON_CHANGE_FULLSCREEN: string = "onchangefullscreen";
    public static ON_HIDE = "ondialoghide";

    public params: any[] = null;

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
